import React from 'react'
import { connect } from 'react-redux'

const styles = {
  main: {
    padding: 5,
    'font-size': '16px',
  },
  linear_progress: {
    height: '10px',
  },
}


class PreMissionShow extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      total_done_repeats: props.total_done_repeats + 1,
      total_max_repeats: props.total_max_repeats,
    }
  }

  color = () =>
    (this.state.total_done_repeats === this.state.total_max_repeats ?
      '#00c853' :
      '#bbbbbb')

  text = () =>
    `  ${this.props.total_done_repeats + 1} / ${this.props.total_max_repeats}`

  render() {
    return (
      <div
        style={styles.main}
        className="mui--text-headline mui--text-center"
      >
        <span>Veces terminada: </span>
        <span style={{ color: this.color() }}>
          { this.text() }
        </span>
      </div>
    )
  }
}

PreMissionShow.propTypes = {
  total_done_repeats: React.PropTypes.number,
  total_max_repeats: React.PropTypes.number,
}

const mapStateToProps = state => ({
  total_done_repeats: state.missions.selectedMission.total_done_repeats,
  total_max_repeats: state.missions.selectedMission.total_max_repeats,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(PreMissionShow)



// WEBPACK FOOTER //
// ./src/components/MissionFinish/SummaryMission/MissionAdvance/index.jsx